import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CMS } from '../../utils/CMS';
import { getGeoLocationPosition } from '../../redux/geoLocations/actions';
import { ConnectedLocationsList } from '../LocationAutocomplete/LocationsList';
import { LegType } from '../../models';
import { DropdownItem } from '../../components/DropdownItem/DropdownItem';
import { TrackingUtils, LocalStorageUtils } from '../../utils';

export class GeoLocationSelector extends PureComponent {
    state = {
        clicked: false,
    };

    onSuccess = (position, transportType) => {
        const { getGeoLocationPosition } = this.props;
        getGeoLocationPosition(position, transportType);
        TrackingUtils.trackEvent({ action: 'location_request_widget', label: 'location_request_accepted_home' });
    }

    onError = () => {
        LocalStorageUtils.setJSON('geoLocAllowed', false);
        TrackingUtils.trackEvent({ action: 'location_request_widget', label: 'location_request_denied_home' });
    }

    onClickGeoButton = (activeProduct) => {
        const transportType = activeProduct === 'trains' ? 'TRAIN' : 'FLIGHT';
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => this.onSuccess(position, transportType),
                this.onError
            );
            this.setState({ clicked: true });
            TrackingUtils.trackEvent({ action: 'location_request_button', label: 'location_request_clicked_origin' });
        } else {
            this.onError();
        }
    }

    getLocations = () => {
        const { geoLocationPosition } = this.props;
        return geoLocationPosition && geoLocationPosition.cities ? geoLocationPosition.cities : [];
    }

    render() {
        const { show, onClickItem, activeProduct } = this.props;
        const { clicked } = this.state;
        const locations = this.getLocations();
        return show && (
            <React.Fragment>
                {!clicked && (
                    <DropdownItem
                        onClick={this.onClickGeoButton(activeProduct)}
                        iconClass='odf-icon-location'
                        isFixedWidth
                        isShowIcon
                    >
                        <span><CMS id='airportSelector.geolocation.current' /></span>
                    </DropdownItem>
                )}
                { clicked && locations && (
                    <ConnectedLocationsList
                        displayedWord=''
                        suggestionsList={locations}
                        onClickItem={onClickItem}
                        departureOrArrival={LegType.DEPARTURE}
                        isFixedWidth
                    />
                )}
            </React.Fragment>
        );
    }
}

GeoLocationSelector.propTypes = {
    getGeoLocationPosition: PropTypes.func.isRequired,
    onClickItem: PropTypes.func.isRequired,
    geoLocationPosition: PropTypes.object.isRequired,
    show: PropTypes.bool,
    activeProduct: PropTypes.string,
};

GeoLocationSelector.defaultProps = {
    show: false,
};

const mapStateToProps = ({ geoLocations }) => ({
    geoLocationPosition: geoLocations.geoLocationPosition,
});

const connected = connect(mapStateToProps, {
    getGeoLocationPosition,
})(GeoLocationSelector);

export { connected as ConnectedGeoLocationSelector };
